<script lang="ts">
    import ReviewsRatingStars from "@apps/reviews/components_v2/ReviewsRatingStars/ReviewsRatingStars.svelte";
    import { REVIEWS_BRANDING_PRODUCT_AVG_RATING_DISPLAY_STYLE } from "@apps/reviews/constants";
    import Text from "@components_v2/Typography/Text.svelte";
    import { GwI18n } from "@modules/i18n/GwI18n/GwI18n";

    import T from "@components/T.svelte";

    export let averageReviewsRating: number;
    export let reviewsCount: number;
    export let displayStyle: REVIEWS_BRANDING_PRODUCT_AVG_RATING_DISPLAY_STYLE;
    export let gwI18n: GwI18n;

    const product_no_reviews_yet$ = gwI18n.selectT(
        "reviews.ReviewsStarRatingWidget",
        "product_no_reviews_yet"
    );
</script>

{#if displayStyle === REVIEWS_BRANDING_PRODUCT_AVG_RATING_DISPLAY_STYLE.SHOW_STARS_ONLY}
    <ReviewsRatingStars
        rating={averageReviewsRating}
        emptyIconTitle={$product_no_reviews_yet$}
    />
{:else}
    <div class="gw-rv-star-rating-summary">
        <ReviewsRatingStars
            rating={averageReviewsRating}
            emptyIconTitle={$product_no_reviews_yet$}
        />
        <Text variant="heading-sm" fontWeight="medium" tone="inherit">
            {#if reviewsCount === 1}
                1 <T
                    namespace="reviews.ReviewsStarRatingWidget"
                    translationKey="review"
                />
            {:else if reviewsCount === 0}
                <T
                    namespace="reviews.ReviewsStarRatingWidget"
                    translationKey="no_reviews"
                />
            {:else}
                <T
                    namespace="reviews.ReviewsStarRatingWidget"
                    translationKey="reviews"
                    translationOptions={{
                        count: reviewsCount,
                    }}
                />
            {/if}
        </Text>
    </div>
{/if}

<style>
    .gw-rv-star-rating-summary {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        gap: var(--gw-space-200);
    }
</style>
